module.exports = __webpack_public_path__ + "img/rascrut-13.e5e66155.jpg";